import GrammarApi, { ObservationType, ParamType, PartParamType } from "../api/GrammarApi";

export default class LocalStorageService {
  static getObservationTypes() {
    return JSON.parse(localStorage.getItem("observationTypes"));
  }

  static getObservationType(code: string): ObservationType {
    const obsTypeArray = JSON.parse(localStorage.getItem("observationTypes")) as ObservationType[];
    return obsTypeArray.find((e) => e.code === code);
  }

  static getParamType(code: string): ParamType {
    const paramTypes = JSON.parse(localStorage.getItem("paramTypes")) as ParamType[];
    return paramTypes.find((e) => e.code === code);
  }

  static getParamTypeAsync(code: string, grammarApi: GrammarApi): Promise<ParamType> {
    return new Promise((resolve) => {
      const paramTypes = JSON.parse(localStorage.getItem("paramTypes")) as ParamType[];

      if (paramTypes) {
        resolve(paramTypes.find((e) => e.code === code));
      } else {
        grammarApi.getParamTypes().then((data) => {
          console.info("Refresh local param types");
          localStorage.setItem("paramTypes", JSON.stringify(data));
          resolve(data.find((e) => e.code === code));
        });
      }
    });
  }

  static getPartParamType(code: string): PartParamType {
    const partParamTypes = JSON.parse(localStorage.getItem("partParamTypes")) as PartParamType[];
    return partParamTypes.find((e) => e.code === code);
  }
}
